import React from "react";
import {
  ConfigProvider,
  Flex,
  Slider,
  SliderSingleProps,
  Typography,
} from "antd";
import styled from "styled-components";
import { useAntTheme } from "hooks/useAntTheme";

export interface SettingSliderProps extends SliderSingleProps {
  label?: React.ReactNode | string;
  valueSuffix?: string;
  showValue?: boolean;
  containerStyle?: React.CSSProperties;
}

export const SettingSlider = ({
  label,
  onChange,
  onChangeComplete,
  value,
  valueSuffix,
  showValue = true,
  containerStyle,
  ...sliderProps
}: SettingSliderProps) => {
  const { theme } = useAntTheme();
  const formatter = (value: number) => {
    if (valueSuffix) {
      return (
        <Typography.Text style={{ fontWeight: 500 }}>
          {value} {valueSuffix}
        </Typography.Text>
      );
    }
    return value;
  };
  return (
    <Flex
      align="center"
      gap={6}
      justify="space-between"
      data-testid="slider"
      style={{ padding: 3, ...containerStyle }}
    >
      <ConfigProvider
        theme={{
          components: {
            Typography: {
              fontSize: 12,
            },
            Slider: {
              trackBg: theme.colorBgContainerDisabled,
              trackHoverBg: theme.colorBgContainerDisabled,
              handleColor: theme.colorTextBase,
              handleActiveColor: theme.colorTextBase,
            },
          },
        }}
      >
        {label &&
          (typeof label === "string" ? (
            <Typography.Text style={{ color: theme.colorTextBase }}>
              {label}
            </Typography.Text>
          ) : (
            label
          ))}
        <StyledSlider
          value={value}
          onChange={onChange}
          onChangeComplete={onChangeComplete}
          tooltip={{
            open: false,
          }}
          {...sliderProps}
        />
        {showValue && value && <StyledValue>{formatter(value)}</StyledValue>}
      </ConfigProvider>
    </Flex>
  );
};
const StyledValue = styled(Typography.Text)`
  padding: 2px 6px;
  border-radius: 3px;
  display: inline-block;
`;

const StyledSlider = styled(Slider)`
  width: 80px;
  .ant-slider-track {
    height: 2px;
    background-color: ${({ theme }) => theme.colorBlack};
  }
  &:hover {
    .ant-slider-track {
      background-color: ${({ theme }) => theme.colorBlack};
    }
  }
  .ant-slider-rail {
    height: 2px;
    background-color: ${({ theme }) => theme.colorBgContainerDisabled};
  }
  .ant-slider-handle::after {
    background-color: ${({ theme }) => theme.colorBlack};
  }
`;
